/**
 * Builds the SSO login entry path with a post-login return URL.
 */
export function buildSsoLoginRedirectPath(returnPath: string): string {
	return `/auth/login?onLoginSuccessRedirectTo=${encodeURIComponent(returnPath)}`;
}

/**
 * Builds the storefront `/login` path with a post-login return URL.
 * Guards that redirect to `/login` must pass this so SSO returns to the
 * protected page instead of `/`.
 */
export function buildLoginRedirectPath(returnPath: string): string {
	return `/login?onLoginSuccessRedirectTo=${encodeURIComponent(returnPath)}`;
}

export function buildLoginRedirectPathFromRequest(request: Request): string {
	const url = new URL(request.url);
	return buildLoginRedirectPath(url.pathname + url.search);
}

/**
 * Redirects the browser to the SSO login entry route with a post-login return URL.
 */
export function redirectToSsoLogin(pathname: string, search: string): void {
	window.location.href = buildSsoLoginRedirectPath(pathname + search);
}
